module.exports = __webpack_public_path__ + "static/media/star_ratings.b2bc4642.svg";